import React from "react";
import moment from "moment";

//UI
import { Form, Row, Col, Tabs } from "antd";

import { BILLING_METHOD } from "../../../utils/onboarding-helper";

import "./styles.css";

const CustomerDataContainer = (props) => {
  const { customer, corporateContact } = props;

  return (
    <Form layout="vertical" className="customer-data-card">
      <Row>
        <Col span={8}>
          <Form.Item label="Customer Name">{customer.customer_name}</Form.Item>
          <Form.Item label="Project Overview">
            {customer.project_overview}
          </Form.Item>
          <Form.Item label="Address Line 1">
            {customer.address_line_1}
          </Form.Item>
          <Form.Item label="Address Line 2">
            {customer.address_line_2}
          </Form.Item>
          <Form.Item label="City">{customer.city}</Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="State">{customer.state}</Form.Item>
          <Form.Item label="Country">{customer.country}</Form.Item>
          <Form.Item label="Zip Code">{customer.zip_code}</Form.Item>
          <Form.Item label="Contract Date">
            {moment(customer.contract_date).format("MM.DD.YYYY")}
          </Form.Item>
          <Form.Item label="Effective Date">
            {moment(customer.effective_date).format("MM.DD.YYYY")}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Solution">{customer.solution}</Form.Item>
          <Form.Item label="Corporate Contract First Name">
            {corporateContact.first_name}
          </Form.Item>
          <Form.Item label="Corporate Contract Last Name">
            {corporateContact.last_name}
          </Form.Item>
          <Form.Item label="Corporate Contract Phone Number">
            {corporateContact.phone_number}
          </Form.Item>
          <Form.Item label="Corporate Contract Email">
            {corporateContact.email}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

const BillingDataContainer = (props) => {
  const { customer } = props;

  return (
    <Form layout="vertical" className="customer-data-card">
      <Row>
        <Col span={8}>
          <Form.Item label="Billing Method">
            {customer.billing_method}
          </Form.Item>
          <Form.Item label="Billing Timeline">
            {customer.billing_timeline}
          </Form.Item>
          <Form.Item label="Address Line 1">
            {customer.billing_details?.address_line_1 ||
              BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
          <Form.Item label="Address Line 2">
            {customer.billing_details?.address_line_2 ||
              BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="City">
            {customer.billing_details?.city || BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
          <Form.Item label="State">
            {customer.billing_details?.state || BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
          <Form.Item label="Country">
            {customer.billing_details?.country || BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
          <Form.Item label="Zip Code">
            {customer.billing_details?.zip_code || BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Billing Contract Name">
            {customer.billing_details?.name || BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
          <Form.Item label="Billing Contract Phone Number">
            {customer.billing_details?.phone_number ||
              BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
          <Form.Item label="Billing Contract Email">
            {customer.billing_details?.email || BILLING_METHOD.INDIVIDUAL}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

const CustomerDataCard = (props) => {
  const { customer, corporateContact, onChange } = props;

  const items = [
    {
      key: "customer-details",
      label: "Customer Details",
      children: (
        <CustomerDataContainer
          customer={customer}
          corporateContact={corporateContact}
        />
      ),
    },
    {
      key: "billing-details",
      label: "Billing Details",
      children: <BillingDataContainer customer={customer} />,
    },
  ];

  return <Tabs defaultActiveKey="1" items={items} onChange={onChange} />;
};

export default CustomerDataCard;
